export default __webpack_public_path__ + "678d69d17e2bed23c226f5309ac07ec4.gif";